export type AppType = 'versirent' | 'idealone';

export interface SupportContactInfo {
  email: string;
  phone: string;
  hours: string;
}

/** Matches functions/src/config apps.*.support* — keep in sync. */
export const SUPPORT_CONTACT_DEFAULTS: Record<AppType, SupportContactInfo> = {
  versirent: {
    email: 'fsdsupport@idealss.com',
    phone: '601-703-0324',
    hours: 'Mon-Fri 9AM-6PM EST (Extended hours available at additional cost)',
  },
  idealone: {
    email: 'fecsupport@idealss.com',
    phone: '601-703-0165',
    hours: '24/7/364 (Just Christmas is a real Holiday)',
  },
};

/**
 * Prefer project.supportContact when both email and phone are set;
 * otherwise use app-type defaults (never placeholder yourcompany/555 numbers).
 */
export function resolveSupportContact(
  appType: AppType,
  projectContact?: Partial<SupportContactInfo> | null
): SupportContactInfo {
  const defaults = SUPPORT_CONTACT_DEFAULTS[appType];
  const email = projectContact?.email?.trim();
  const phone = projectContact?.phone?.trim();
  const hours = projectContact?.hours?.trim();

  if (email && phone) {
    return {
      email,
      phone,
      hours: hours || defaults.hours,
    };
  }

  return { ...defaults };
}

export function supportPhoneTelHref(phone: string): string {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}
